import { createFileRoute, notFound } from '@tanstack/react-router'
import { caseViewQuery } from '../features/case-view'
import { ApiError } from '../features/case-view/api'
import { projectQuery } from '../features/projects/api'
import { ProjectNotFound, ProjectPage } from '../features/projects/project-page'

const isMissing = (e: unknown): boolean => {
  const status = (e as { status?: number } | null)?.status
  return (e instanceof ApiError && e.status === 404) || status === 404 || status === 422
}

/** #1388 slice 86: the project page is the home case's screen plus the project strip and the Plan tab. */
export const Route = createFileRoute('/project/$id')({
  loader: async ({ context, params }) => {
    try {
      const project = await context.queryClient.ensureQueryData(projectQuery(params.id))
      await context.queryClient.ensureQueryData(caseViewQuery(project.home_case.number))
    } catch (e) {
      if (isMissing(e)) throw notFound()
      throw e
    }
    return null
  },
  notFoundComponent: function ProjectMissing() {
    const { id } = Route.useParams()
    return <ProjectNotFound reference={id} />
  },
  component: function ProjectRoute() {
    const { id } = Route.useParams()
    return <ProjectPage key={id} projectId={id} />
  },
})
